const inprogressBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M7.254 3.996H8.75V7.25H12v1.5H7.246z" clip-rule="evenodd"/></svg>',
};

export { inprogressBold as default };
